export const PriceQuiz = {
  className: "slideLR priceQ",
  type: "RightWrong",
  imgPath: "https://s3-us-west-2.amazonaws.com/s.cdpn.io/40041/",
  questions: [
    {
      question: "How much did an answering machine cost in 1986?",
      choices: ["$99.99 ", "$29.99 ", "$149.99 ", "$19.99"],
    },
    {
      question:"If Courtney wanted to buy a cassette player with headphones, how much money would she need? ",
      choices: ["$69.99 ", "$49.99 ", "$99.99 ", "$9.99"],
    },

    {
      question: "What would Courtney have to pay for a boom box? ",
      choices: ["$89.99 ", "$109.99 ", "$17.99 ", "$149.99"],
    },

    {
      question:"Courtney loved making mixtapes, so she had to buy blank cassette tapes. How much did a pack of two tapes cost? ",
      choices: ["$1.98 ", "$2.98 ", "$9.98 ", "$5.98"],
    },

    {
      question: "How much did a VCR cost in 1986? ",
      choices: ["$329.99 ", "$149.99 ", "$424.99 ", "$99.99"],
    },

    {
      question: "Courtney bought her dad a VHS tape rewinder for Christmas. How much did she spend?",
      choices: ["$49.99 ", "$19.99 ", "$124.99 ", "$74.99"],
    },

    {
      question: "Cordless phones were available in 1986. How much did one cost?",
      choices: ["$89.99 ", "$74.99 ", "$29.99 ", "$149.99"],
    },
    {
      question: "Kip’s dad had a camcorder. How much did he pay for it?",
      choices: ["$699.99 ", "$199.99 ", "$899.99 ", "$499.99"],
    },
  ],
  results: [
    {
      title: "Nice Try!",
      copy:
        "You definitely didn’t do any shopping in the 1980s. You got [correct] out of [total] correct! That’s okay. Want to try again?",
    },
    {
      title: "Good Job!",
      copy: "You’re pretty good with prices from a previous century. You got [correct] out of [total] correct! That's good",
    },
    {
      title: "Wow!",
      copy: "You got [correct] out of [total] correct! You’d fit right in at Orange Valley Mall in 1986!",
    },
  ],
};
